module.exports = __webpack_public_path__ + "fonts/a70b644.ttf";